import React from "react";
import { IoCheckmarkCircle } from "react-icons/io5";

const KycVerified = () => {
  return (
    <div className="w-full flex flex-col items-center justify-center py-10 gap-8">
      <div className="flex flex-col items-center text-center px-6 py-10 rounded-xl max-w-md mx-auto">
        <IoCheckmarkCircle className="text-green-600 w-20 h-20 mb-8" />
        <h2 className="text-3xl font-bold mb-3">KYC Verified</h2>
        <p className="text-gray-500 text-base">
          Your identity verification is complete. You can continue with onboarding.
        </p>
      </div>
    </div>
  );
};

export default KycVerified;
